import React, { useState, useContext, useEffect } from "react";
import Modal from "common/Modal.jsx";
import ActionsContext from "common/ActionsContext";
import Fields from "./Fields";
import SelectAutocomplete from "common/SelectAutocomplete";
import BqnContext from "common/BqnContext";
import styled from "styled-components";

const doesNothing = () => {};

const WrapperSelect = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 7px 15px 7px;
`;

const SelectTitle = styled.div`
  margin-right: 20px;
  font-family: "AllianceNo2-SemiBold" !important;
  font-size: 13px;
`;

const CreateRangeModal = ({
  doValidate = doesNothing,
  doSave = doesNothing,
  onClose = doesNothing,
  managementInterfaces
}) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);
  const [bqnSelected, setBqnSelected] = useState(null);

  const actions = useContext(ActionsContext);

  const {
    bqnId,
    bqns,
    loginBqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);

  useEffect(() => {
    setBqnSelected(bqnId === "all" ? loginBqnId : bqnId);
  }, [bqnId])
  
  useEffect(() => actions.recv("new-range", doOpen), []);
  
  const doClose = () => {
    setOpen(false);
    onClose();
  };
  const doOpen = () => {
    setError(null);
    setOpen(true);
  }

  
  if (open === false) {
    return null;
  }

  const handleChange = ({target}) => {
    try {
      doValidate({[target.name]: target.value, bqn: bqnSelected})
      setError(null);
    } catch (error) {
      setError(error);
    }
  };

  const doApply = (update) => {
    try {
      doSave({...update, bqn: bqnSelected, interface: managementInterfaces[bqnSelected]});
      doClose();
    } catch (error) {
      setError(error);
    }
    return false;
  };

  const options = bqns.map(({ bqnId }) => {
    return { label: bqnId, value: bqnId };
  });
  
  return (
    <Modal
      title="Create Range"
      superIcon="cloud_queue"
      large={false}
      content={() => (
        <>
          {mode === "cluster" && (
            <WrapperSelect>
              <SelectTitle>Select BQN</SelectTitle>
              <SelectAutocomplete
                title="bqn-select"
                name="bqn-select"
                selected={bqnSelected.toString()}
                onChange={(value) => {
                  setBqnSelected(value);
                }}
                options={options}
                className="license-select"
              />
            </WrapperSelect>
          )}
          <Fields onChange={handleChange} />
        </>
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={error !== null}
      closeLabel="CANCEL"
      onClose={doClose}
      footerMessage={
        (error !== null && (
          <span className="modal-err-msg color-red align-left">{error}</span>
        )) ||
        null
      }
    />
  );
};
export default CreateRangeModal;
